import { z } from 'zod';

export const NotificationDeliveryBounceSchema = z.object({
    providerMessageId: z.string().trim().min(1).max(500),
    eventType: z.enum(['bounce', 'complaint', 'dsn']).default('bounce'),
    recipient: z.string().trim().max(320).optional(),
    reason: z.string().trim().max(1000).optional(),
    diagnosticCode: z.string().trim().max(240).optional(),
}).strict();
